export default __webpack_public_path__ + "static/media/admin.3d995c3b.png";